module.exports = __webpack_public_path__ + "static/img/3.6601300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/3.jpg
// module id = hLkA
// module chunks = 4